<app-form (submit)="save()" data-modal-backdrop-static>
    <div class="card">
        <div class="card-header">
            <h3 class="card-header-title">Configure meter split</h3>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <p class="text-muted">Divide this meter's measurements among virtual child meters.</p>

            <div *ngFor="let allocation of allocations; let i = index; trackBy: trackByMeterId"
                 class="border rounded p-3 mb-3">
                <div class="row align-items-end g-3">
                    <div class="col-12 col-md">
                        <app-form-field label="Label">
                            <input [(ngModel)]="allocation.details.label" [ngModelOptions]="{standalone: true}"
                                   type="text" class="form-control">
                        </app-form-field>
                    </div>
                    <div class="col-8 col-md-3">
                        <app-form-field label="Percentage" [renderOptional]="false">
                            <div class="input-group">
                                <input [(ngModel)]="allocation.percentage" [ngModelOptions]="{standalone: true}"
                                       type="number" class="form-control" min="0.1" max="100" step="0.1" required>
                                <span class="input-group-text">%</span>
                            </div>
                        </app-form-field>
                    </div>
                    <div class="col-auto d-flex gap-1 pb-3">
                        <button type="button" class="btn btn-outline-danger" title="Remove allocated meter"
                                aria-label="Remove allocated meter" [disabled]="allocations.length <= 2"
                                (click)="removeAllocation(i)">
                            <i class="bi bi-trash" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-outline-primary" [disabled]="allocations.length >= maxAllocations"
                    (click)="addAllocation()">
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Add allocated meter
            </button>

            <div class="d-flex justify-content-end mt-3">
                <strong>Total: {{ totalPercentage() | number:'1.1-1' }}%</strong>
            </div>
            <p *ngIf="!isValid()" class="text-danger text-end mb-0">Percentages must total 100% and use at most one decimal place.</p>
        </div>

        <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
                <button *ngIf="hasExistingSplit" type="button" class="btn btn-outline-danger"
                        (click)="confirmUnsplit()">Unsplit meter</button>
                <span *ngIf="!hasExistingSplit"></span>
                <div class="d-flex gap-2">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!isValid()">Save split</button>
                </div>
            </div>
        </div>
    </div>
</app-form>
